import {React, useEffect} from "react";
import {styled} from "@mui/system";
import {Grid} from "@mui/material";
import {navigate} from "react-router-dom";

const ThankYouPageContainer = styled("div")({
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  background: "linear-gradient(180deg, #4b6cb7 0%, #182848 100%)", // Adjust the gradient colors as needed
  color: "white",
  textAlign: "center",
  padding: "20px",
});

const Title = styled("h1")({
  fontSize: "48px",
  margin: "0 0 20px 0",
  fontWeight: "bold",
});

const Subtitle = styled("h2")({
  fontSize: "24px",
  margin: "0 0 20px 0",
  fontWeight: "normal",
});

const Content = styled("p")({
  fontSize: "20px",
  lineHeight: "1.5",
});

const LogoContainer = styled(Grid)({
  justifyContent: "center",
  marginLeft: "-160px", // Center horizontally in the grid container
});

const Thankyou = () => {
  useEffect(() => {
    const handleBackButtonEvent = () => {
      window.location.reload();
    };

    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", handleBackButtonEvent);

    return () => {
      window.removeEventListener("popstate", handleBackButtonEvent);
    };
  }, []);

  return (
    <ThankYouPageContainer>
      <LogoContainer>
        <Grid className="logo_logo">
          <img
            src={require("../assets/images/sunwareLogo.png")}
            alt="Company Logo"
            width="100px"
          />
        </Grid>
      </LogoContainer>
      <Title>Thank You!</Title>
      <Subtitle>Your submission has been received</Subtitle>
      <Content>
        We appreciate you taking the time to complete the quiz. We will process
        your answers and get back to you with the next steps shortly.
      </Content>
      <div style={{ position: "fixed", bottom: "10px", right: "16px", fontSize: "12px", color: "rgba(255,255,255,0.6)" }}>
        © 2026 Sunware Technologies. All rights reserved.
      </div>
    </ThankYouPageContainer>
  );
};

export default Thankyou;
